var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisputeSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 111,
    viewBox: "0 0 113 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2927 92.6453C80.3601 92.6453 99.8783 73.2389 99.8783 49.2746C99.8783 25.3105 80.3601 5.90381 56.2927 5.90381C32.2252 5.90381 12.707 25.3105 12.707 49.2746C12.707 73.2389 32.2252 92.6453 56.2927 92.6453Z",
    fill: "#F8F4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7643 28.5449C100.426 28.5449 101.773 27.1956 101.773 25.531C101.773 23.8665 100.426 22.5171 98.7643 22.5171C97.1031 22.5171 95.7559 23.8665 95.7559 25.531C95.7559 27.1956 97.1031 28.5449 98.7643 28.5449Z",
    fill: "#F8F4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7577 18.7679C96.8921 18.7679 97.8122 17.8464 97.8122 16.7096C97.8122 15.5729 96.8921 14.6514 95.7577 14.6514C94.6225 14.6514 93.7031 15.5729 93.7031 16.7096C93.7031 17.8464 94.6225 18.7679 95.7577 18.7679Z",
    fill: "#F8F4F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5487 25.5311C13.6834 25.5311 14.6032 24.6096 14.6032 23.4728C14.6032 22.3361 13.6834 21.4146 12.5487 21.4146C11.414 21.4146 10.4941 22.3361 10.4941 23.4728C10.4941 24.6096 11.414 25.5311 12.5487 25.5311Z",
    fill: "#F8F4F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92497 70.813C10.0323 70.813 11.7406 69.1016 11.7406 66.9905C11.7406 64.8794 10.0323 63.168 7.92497 63.168C5.81766 63.168 4.10938 64.8794 4.10938 66.9905C4.10938 69.1016 5.81766 70.813 7.92497 70.813Z",
    fill: "#F8F4F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1504_78078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.4485 38.5372V78.336C96.4485 78.5 96.4485 78.5823 96.4485 78.7462C96.3663 81.0441 95.3016 83.0135 93.6631 84.4087C92.2704 85.6392 90.3868 86.4596 88.3389 86.4596H24.2031C22.8106 86.4596 21.5001 86.1318 20.3533 85.4753C19.8619 85.2291 19.3704 84.9005 18.9609 84.4903C18.0599 83.7522 17.2408 82.6849 16.8312 81.5359C16.5035 80.7156 16.2578 79.8129 16.2578 78.9101V38.5372C16.2578 38.5372 19.6161 35.6651 24.4488 31.7263C29.4454 27.5413 35.9983 22.1253 41.732 17.3659C45.0084 14.5759 44.6808 14.9042 49.7592 10.6371C53.609 7.3547 59.2608 7.3547 63.1106 10.6371C64.0935 11.4577 65.1583 12.4424 66.1413 13.263C68.271 14.9862 70.5644 16.9556 73.0217 19.0071C78.1821 23.2742 83.8343 28.0336 88.2574 31.7263C92.762 35.419 96.0383 38.209 96.4485 38.5372Z",
    fill: "url(#paint0_linear_1504_78078)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2569 31.6441V45.9223L74.2507 54.3744L70.0731 56.9183L61.2268 62.2521L57.0494 64.796L55.2473 65.8627L53.5272 64.796L49.5955 62.2521L41.1587 56.9183L37.227 54.3744L24.2852 46.2506V31.7261C29.2817 27.541 35.8345 22.1251 41.5683 17.3657L72.94 18.9249C78.1823 23.274 83.8337 27.9514 88.2569 31.6441Z",
    fill: "#90388B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4725 20.3198V45.4299L72.6946 53.0614L68.9267 55.359L60.8175 60.1185L57.0496 62.4161L55.4114 63.3188L53.8551 62.4161L50.2511 60.1185L42.5515 55.359L38.9474 53.0614L27.1523 45.6761V20.3198C27.1523 17.6939 29.282 15.5603 31.9851 15.5603H80.6399C83.261 15.4783 85.4725 17.6939 85.4725 20.3198Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.5859 38.373L55.0839 40.9169L95.8752 38.373L94.3189 45.6763C94.3189 45.6763 55.9849 65.6988 56.2306 65.6988C56.4763 65.6988 16.6679 41.9837 16.6679 41.9837L16.5859 38.373Z",
    fill: "url(#paint1_linear_1504_78078)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7453 84.4086C92.3526 85.6391 90.469 86.4595 88.4211 86.4595H24.2031C22.8106 86.4595 21.5001 86.1316 20.3533 85.4752C19.8619 85.2289 19.3704 84.9003 18.9609 84.4902C18.0599 83.7514 17.2408 82.6847 16.8312 81.5358C16.5035 80.7154 16.2578 79.8127 16.2578 78.91V78.8284V38.5371L20.4352 41.0809L56.3121 62.3343L57.2949 62.9087L57.3768 62.9908L89.568 82.0283L93.7453 84.4086Z",
    fill: "url(#paint2_linear_1504_78078)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2958 61.6777V64.4677L20.3542 85.4751C19.8627 85.2288 19.3712 84.9002 18.9616 84.4901C18.0606 83.752 17.2415 82.6847 16.832 81.5364L52.7907 60.2007L55.9033 62.1701L56.3128 62.3342L57.2958 61.6777Z",
    fill: "url(#paint3_linear_1504_78078)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2578 38.5371L56.3121 62.3343",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4479 38.5371V78.7461C96.3664 81.044 95.3018 83.0133 93.6633 84.4086C92.2706 85.6391 90.387 86.4595 88.339 86.4595H24.2032C22.8107 86.4595 21.5001 86.1316 20.3534 85.4752C19.8619 85.2289 19.3705 84.9003 18.9609 84.4902L23.0565 82.0283L55.2473 62.9908L56.3121 62.3343L57.295 61.7599L92.1891 40.9989L96.4479 38.5371Z",
    fill: "url(#paint4_linear_1504_78078)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4479 38.5371L57.295 61.6778L56.3121 62.3343L55.2473 62.9908L18.9609 84.4086",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7835 66.6833H65.4869C64.9955 66.6833 64.5859 66.2729 64.5859 65.7806C64.5859 65.2883 64.9955 64.8779 65.4869 64.8779H86.7835C87.2752 64.8779 87.6846 65.2883 87.6846 65.7806C87.7668 66.2729 87.3573 66.6833 86.7835 66.6833Z",
    fill: "#E8D6EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7835 72.838H65.4869C64.9955 72.838 64.5859 72.4277 64.5859 71.9353C64.5859 71.443 64.9955 71.0327 65.4869 71.0327H86.7835C87.2752 71.0327 87.6846 71.443 87.6846 71.9353C87.7668 72.4277 87.3573 72.838 86.7835 72.838Z",
    fill: "#E8D6EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2628 46.9337C53.628 46.9337 53.0305 46.7 52.545 46.1936L44.292 37.5841C43.3584 36.6101 43.3584 34.974 44.292 34C45.2256 33.0261 46.794 33.0261 47.7277 34L54.2628 40.8175L69.6486 24.8061C70.5821 23.8322 72.1506 23.8322 73.0842 24.8061C74.018 25.7801 74.018 27.4163 73.0842 28.3902L55.9806 46.1936C55.5325 46.7 54.8977 46.9337 54.2628 46.9337Z",
    fill: "url(#paint5_linear_1504_78078)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1504_78078",
    x: 6.25781,
    y: 2.17529,
    width: 100.191,
    height: 98.2842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1504_78078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1504_78078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1504_78078",
    x1: 93.2674,
    y1: 8.1753,
    x2: 18.7031,
    y2: 8.44123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1504_78078",
    x1: 56.0771,
    y1: 64.848,
    x2: 56.0771,
    y2: 50.5344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00870001,
    stopColor: "#E8D6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1504_78078",
    x1: 54.9766,
    y1: 37.4286,
    x2: 54.9766,
    y2: 86.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1504_78078",
    x1: 36.9856,
    y1: 84.6881,
    x2: 36.9856,
    y2: 71.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#E8D6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1504_78078",
    x1: 57.6795,
    y1: 37.4286,
    x2: 57.6795,
    y2: 86.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F8F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1504_78078",
    x1: 72.5868,
    y1: 24.0757,
    x2: 44.5127,
    y2: 24.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeSuccessIcon);
export default __webpack_public_path__ + "static/media/dispute_success_icon.0aa27d327420a145ef0cad6061ce7db0.svg";
export { ForwardRef as ReactComponent };